import { LangKey } from '@/utils/types/langKey';

export enum LangKeyType {
  en = 'en',
  zh = 'zh',
}

export const AUTH_TOKEN_EXPIRY_CLIENT_TIME_STORAGE_KEY = 'airwallex_webapp_auth_token_expiry_client_time';
export const AUTH_TOKEN_STORAGE_KEY = 'airwallex_webapp_auth_token';
export const LANGKEY = 'ls.langKey';

const get = (key: string): string | null => window.localStorage.getItem(key);
const set = (key: string, value: string): void => window.localStorage.setItem(key, value);
const remove = (key: string): void => window.localStorage.removeItem(key);

export const setAuthToken = (token: string): void => {
  return set(AUTH_TOKEN_STORAGE_KEY, token);
};

export const getAuthToken = (): string | null => {
  return get(AUTH_TOKEN_STORAGE_KEY);
};

export const setAuthTokenExpiry = (time: number): void => {
  return set(AUTH_TOKEN_EXPIRY_CLIENT_TIME_STORAGE_KEY, time.toString());
};

export const getAuthTokenExpiry = (): string | null => {
  return get(AUTH_TOKEN_EXPIRY_CLIENT_TIME_STORAGE_KEY);
};

export const removeAuthTokenStorage = (): void => {
  remove(AUTH_TOKEN_STORAGE_KEY);
  remove(AUTH_TOKEN_EXPIRY_CLIENT_TIME_STORAGE_KEY);
};

export const setLangToLocalStorage = (langKey: LangKey | string): void => {
  return set(LANGKEY, JSON.stringify(langKey));
};

export const getLangFromLocalStorage = (): string | undefined => {
  return get(LANGKEY)?.replace(/"/g, '');
};
